import React from 'react'
import { useBulkCreateShiftsContextValue } from '../../context/BulkCreateShiftsProvider'
import { Footer } from '../Footer'
import { Box, Button, Flex } from '@workwhile/ui'
import { ReviewTable } from './components/ReviewTable'
import styles from './Review.module.css'

export const Review = () => {
  const {
    state: { formState, createLocationsState, createShiftsState },
    actions: { createLocationsAndShifts, replace },
  } = useBulkCreateShiftsContextValue()

  const handleNext = async () => {
    const result = await createLocationsAndShifts(formState)
    if (result) {
      replace('done')
    } else {
      replace('import')
    }
  }

  return (
    <Flex flexDirection="column" gap={3} height="100%" p={3}>
      <Flex
        flexDirection="column"
        gap={3}
        className={styles.container}
        height="100%"
      >
        <Box className={styles.content}>
          <ReviewTable />
        </Box>
      </Flex>
      <Footer>
        <Button
          variant="secondary"
          onClick={() => replace('import')}
          disabled={
            createLocationsState.isPending || createShiftsState.isPending
          }
        >
          Previous
        </Button>
        <Button
          variant="primary"
          onClick={handleNext}
          disabled={
            createLocationsState.isPending || createShiftsState.isPending
          }
        >
          Create shifts
        </Button>
      </Footer>
    </Flex>
  )
}
